import React from 'react';
import styled from 'styled-components';
import {CSS_CONSTANTS} from '../css_variables';
import {FormattedMessage} from 'react-intl';

const HeaderElement = styled.div`
	font-size: 20px;
	color: ${CSS_CONSTANTS.v2_text_gray};
	font-weight: 500;
`;

const ThirdLevelHeader = ({textId}) => {
	return (
		<HeaderElement>
			<FormattedMessage id={textId}></FormattedMessage>
		</HeaderElement>
	);
};

export default ThirdLevelHeader;
